module.exports = __webpack_public_path__ + "static/media/badge-english-provisional.e4c251ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/badge-english-provisional.png
// module id = 603
// module chunks = 0